import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import tabify from 'shared/containers/tabify';

const TabbedWidget = ({ children, tabs, setActiveTabName, span, className, nopadding }) => (
  <div className={`span${span}`}>
    <div className={cx('TabbedWidget', 'widget-box', className)}>
      <div className="widget-title">
        <ul className="nav nav-tabs">
          {tabs.map(tab => {
            const navItemClasses = cx({ active: tab.active });
            return (
              <li key={tab.name} className={navItemClasses}>
                <span className="fake-link nav-tabs__tab" onClick={tab.onClick}>
                  {tab.name}
                </span>
              </li>
            );
          })}
        </ul>
      </div>

      <div className={cx('TabbedWidget-content', 'widget-content', 'tab-content', { nopadding })}>
        {children}
      </div>
    </div>
  </div>
);

TabbedWidget.displayName = 'TabbedWidget';

TabbedWidget.propTypes = {
  span: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
};

TabbedWidget.defaultProps = {
  span: 8,
};

export default tabify(TabbedWidget);
